<template>
  <div class="md-layout" v-if="Object.keys(game).length > 0 && Object.keys(stats).length > 0">
    <template v-if="game.publishDate == null">
      <!-- Publish -->
      <manage-publish :game="game" :gameId="Number(gameId)"></manage-publish>
    </template>
    
    <template v-else>
      <!-- Status -->
      <manage-status :game="game" :gameId="Number(gameId)" :stats="stats"></manage-status>
      <!-- Goal -->
      <manage-goal :game="game" :gameId="Number(gameId)" :score="score"></manage-goal>

      <div class="md-layout" style="align-items: flex-start;">
        <!-- Team local -->
        <md-card class="md-layout-item md-size-49 md-layout--team" style="margin-right: 1%;">
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">
              <strong>{{$t("games.tabs.interactions")}}: {{game.local.name}}</strong>
              <badge type="danger" v-if="game.status != 'Finished' || game.status != 'Pending'">{{$t("games.stats.live")}} : {{stats.localLive}}</badge>
              <badge type="danger" v-if="game.status == 'Finished' || game.status == 'Pending'">{{$t("games.stats.maxLive")}} : {{stats.maxLocalLive}}</badge>
            </h4>
          </md-card-header>
          <md-toolbar class="md-transparent">
            <div class="md-toolbar-row">
              <div>
                <md-button
                :class="{'md-primary': tabActiveLocal === 'MESSAGES', 'md-simple': tabActiveLocal !== 'MESSAGES'}"
                @click="tabActiveLocal = 'MESSAGES'">{{$t("games.tabs.messages")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.messagesTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveLocal === 'PAPERS', 'md-simple': tabActiveLocal !== 'PAPERS'}"
                @click="tabActiveLocal = 'PAPERS'">{{$t("games.tabs.papers")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.papersTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveLocal === 'SURVEY', 'md-simple': tabActiveLocal !== 'SURVEY'}"
                @click="tabActiveLocal = 'SURVEY'">{{$t("games.tabs.survey")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.surveyTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveLocal === 'PICTURE', 'md-simple': tabActiveLocal !== 'PICTURE'}"
                @click="tabActiveLocal = 'PICTURE'">{{$t("games.tabs.images")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.imagesTooltip")}}</md-tooltip>
              </div>
            </div>
          </md-toolbar>
          <!-- Send message -->
          <manage-message :teamId="game.local.id" :gameId="Number(gameId)" v-if="tabActiveLocal === 'MESSAGES'"></manage-message>
          <!-- Throw papers -->
          <manage-throw-papers :teamId="game.local.id" :gameId="Number(gameId)" v-if="tabActiveLocal === 'PAPERS'"></manage-throw-papers>
          <!-- Send survey -->
          <manage-survey :teamId="game.local.id" :gameId="Number(gameId)" v-if="tabActiveLocal === 'SURVEY'"></manage-survey>
          <!-- Picture -->
          <manage-picture :teamId="game.local.id" :gameId="Number(gameId)" v-if="tabActiveLocal === 'PICTURE'"></manage-picture>
        </md-card>

        <!-- Team visitor -->
        <md-card class="md-layout-item md-size-49 md-layout--team" style="margin-left: 1%;">
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>sports_soccer</md-icon>
            </div>
            <h4 class="title">
              <strong>{{$t("games.tabs.interactions")}}: {{game.visitor.name}}</strong>
              <badge type="danger" v-if="game.status != 'Finished' || game.status != 'Pending'">{{$t("games.stats.live")}} : {{stats.visitorLive}}</badge>
              <badge type="danger" v-if="game.status == 'Finished' || game.status == 'Pending'">{{$t("games.stats.maxLive")}} : {{stats.maxVisitorLive}}</badge>
            </h4>
          </md-card-header>
          <md-toolbar class="md-transparent">
            <div class="md-toolbar-row">
              <div>
                <md-button
                :class="{'md-primary': tabActiveVisitor === 'MESSAGES', 'md-simple': tabActiveVisitor !== 'MESSAGES'}"
                @click="tabActiveVisitor = 'MESSAGES'">{{$t("games.tabs.messages")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.messagesTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveVisitor === 'PAPERS', 'md-simple': tabActiveVisitor !== 'PAPERS'}"
                @click="tabActiveVisitor = 'PAPERS'">{{$t("games.tabs.papers")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.papersTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveVisitor === 'SURVEY', 'md-simple': tabActiveVisitor !== 'SURVEY'}"
                @click="tabActiveVisitor = 'SURVEY'">{{$t("games.tabs.survey")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.surveyTooltip")}}</md-tooltip>
              </div>
              <div>
                <md-button 
                :class="{'md-primary': tabActiveVisitor === 'PICTURE', 'md-simple': tabActiveVisitor !== 'PICTURE'}"
                @click="tabActiveVisitor = 'PICTURE'">{{$t("games.tabs.images")}}</md-button>
                <md-tooltip md-direction="bottom">{{$t("games.tabs.imagesTooltip")}}</md-tooltip>
              </div>
            </div>
          </md-toolbar>
          <!-- Send message -->
          <manage-message :teamId="game.visitor.id" :gameId="Number(gameId)" v-if="tabActiveVisitor === 'MESSAGES'"></manage-message>
          <!-- Throw papers -->
          <manage-throw-papers :teamId="game.visitor.id" :gameId="Number(gameId)" v-if="tabActiveVisitor === 'PAPERS'"></manage-throw-papers>
          <!-- Send survey -->
          <manage-survey :teamId="game.visitor.id" :gameId="Number(gameId)" v-if="tabActiveVisitor === 'SURVEY'"></manage-survey>
          <!-- Picture -->
          <manage-picture :teamId="game.visitor.id" :gameId="Number(gameId)" v-if="tabActiveVisitor === 'PICTURE'"></manage-picture>
        </md-card>
      </div>

      <md-card class="md-layout-item md-size-100">
        
        <md-card-actions>
          <div class="stats">
            <md-button class="md-danger" @click="unpublish()">{{$t("games.unpublish.button")}}</md-button>
            <md-tooltip md-direction="left">{{$t("games.unpublish.buttonTooltip")}}</md-tooltip>
          </div>
        </md-card-actions>
      </md-card>
    </template>

    <!-- Modal Result survey -->
    <modal-survey-results></modal-survey-results>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Badge } from '@/components';
import moment from 'moment';
import ManagePicture from "@/pages/Games/Manage/Picture.vue";
import ManagePublish from "@/pages/Games/Manage/Publish.vue";
import ManageStatus from "@/pages/Games/Manage/Status.vue";
import ManageGoal from "@/pages/Games/Manage/Goal.vue";
import ManageMessage from "@/pages/Games/Manage/Messages.vue";
import ManageThrowPapers from "@/pages/Games/Manage/ThrowPapers.vue";
import ManageSurvey from "@/pages/Games/Manage/Survey.vue";
import ModalSurveyResults from "@/components/ModalSurveyResults.vue";

export default {
  components: {
    Badge,
    ManagePicture,
    ManagePublish,
    ManageStatus,
    ManageGoal,
    ManageMessage,
    ManageThrowPapers,
    ManageSurvey,
    ModalSurveyResults
  },
  computed: {
    ...mapState({
      game: state => state.GameModule.game,
      templates: state => state.SurveyModule.templates
    })
  },
  data() {
    return {
      tabActiveLocal: "MESSAGES",
      tabActiveVisitor: "MESSAGES",
      gameId: '',
      messageLocal: '',
      messageVisitor: '',
      score: {
        local: 0,
        visitor: 0
      },
      stats: {},
      intervalStats: null
    }
  },
  async created() {
    this.gameId = this.$route.params.id
    const request = await this.$store.dispatch('getGame', { gameId: this.gameId })
    if (request != undefined) {
      this.score.local = Number(this.game.score.split('-')[0])
      this.score.visitor = Number(this.game.score.split('-')[1])
      if (this.templates.length == 0) this.$store.dispatch('getTemplates')
      this.getStats()
      this.intervalStats = setInterval(this.getStats, 5000)
    } else {
      this.$store.dispatch("openModalError")
      this.$router.push("/list/games")
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalStats)
  },
  methods: {
    async unpublish() {
      const response = await this.$store.dispatch('unpublish', { gameId: this.gameId })
      if (response != undefined) {
        this.$store.dispatch('getGame', { gameId: this.gameId })
        this.$notify({
          message: this.$t(`notifications.game.unpublish`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    async getStats() {
      const requestStats = await this.$store.dispatch("getStats", { gameId: this.gameId })
      if (requestStats != undefined) {
        this.stats = requestStats.data
      }
    }
  }
}
</script>

<style>
  .md-toolbar {
    padding: 24px 0 0;
  }

  .md-layout--team {
    border: 2px solid #26c6da;
  }
  
  .badge {
    margin: 0 4px;
  }

  .title {
    display: flex;
    align-items: flex-start;
  }    
</style>